import React from 'react'
import { MenuItem } from './MenuItem'

interface MainMenuPanelProps {
  mainPanelRef: React.RefObject<HTMLDivElement>
  showEditField: boolean
  setShowEditField: (show: boolean) => void
  showAddField: boolean
  setShowAddField: (show: boolean) => void
  setAddFieldPosition: (position: 'left' | 'right') => void
  onSortAscendingSelected?: () => void
  onSortDescendingSelected?: () => void
  onPinSelected?: () => void
  onHideInView?: () => void
  onDuplicate?: () => void
  onClearColumn?: () => void
  onDeleteColumn?: () => void
  onVisualizeData?: () => void
}

export function MainMenuPanel({
  mainPanelRef,
  showEditField,
  setShowEditField,
  showAddField,
  setShowAddField,
  setAddFieldPosition,
  onSortAscendingSelected,
  onSortDescendingSelected,
  onPinSelected,
  onHideInView,
  onDuplicate,
  onClearColumn,
  onDeleteColumn,
  onVisualizeData,
}: MainMenuPanelProps) {
  const handleAddColumnLeft = () => {
    setAddFieldPosition('left')
    setShowAddField(true)
  }

  const handleAddColumnRight = () => {
    setAddFieldPosition('right')
    setShowAddField(true)
  }

  return (
    <div
      ref={mainPanelRef}
      className={`transition-transform duration-300 ${showEditField || showAddField ? '-translate-x-full' : 'translate-x-0'}`}
    >
      <div className='py-2'>
        {/* First group */}
        <div className='px-1'>
          <MenuItem
            icon='obvious-settings-slider-hor'
            label='Edit field'
            hasChevron
            onClick={() => setShowEditField(true)}
          />
          <MenuItem
            icon='obvious-line-chart-1'
            label='Visualize Data'
            onClick={onVisualizeData}
          />
        </div>

        {/* Divider */}
        <div className='h-px bg-[#e0e1e6] my-2' />

        {/* Second group */}
        <div className='px-1'>
          <MenuItem
            icon='obvious-arrow-up'
            label='Sort ascending'
            onClick={onSortAscendingSelected}
          />
          <MenuItem
            icon='obvious-arrow-down'
            label='Sort descending'
            onClick={onSortDescendingSelected}
          />
        </div>

        {/* Divider */}
        <div className='h-px bg-[#e0e1e6] my-2' />

        {/* Third group */}
        <div className='px-1'>
          <MenuItem
            icon='obvious-arrow-left'
            label='Add column left'
            hasChevron
            onClick={handleAddColumnLeft}
          />
          <MenuItem
            icon='obvious-arrow-right'
            label='Add column right'
            hasChevron
            onClick={handleAddColumnRight}
          />
        </div>

        {/* Divider */}
        <div className='h-px bg-[#e0e1e6] my-2' />

        {/* Fourth group */}
        <div className='px-1'>
          <MenuItem
            icon='obvious-pin'
            label='Pin column'
            onClick={onPinSelected}
          />
          <MenuItem
            icon='obvious-eye-slash'
            label='Hide in view'
            onClick={onHideInView}
          />
          <MenuItem
            icon='obvious-square-behind-square-4'
            label='Duplicate'
            onClick={onDuplicate}
          />
          <MenuItem
            icon='obvious-circle-x'
            label='Clear column'
            isDestructive
            onClick={onClearColumn}
          />
          <MenuItem
            icon='obvious-trash-can'
            label='Delete column'
            isDestructive
            onClick={onDeleteColumn}
          />
        </div>
      </div>
    </div>
  )
}
